module.exports = __webpack_public_path__ + "img/features-icon.325f75e8.svg";